import api, { masonCtlKey } from "../api";

// API path to the forms service
const path = (p: string) => `tokens${p}`;

type CreateTokenPayload = { username: string; password: string };

/**
 * Create a token
 *
 */
const create = (data: CreateTokenPayload, oauth = false) => {
	return api.request({
		method: "POST",
		url: path(oauth ? "/openid" : ""),
		data,
	});
};

/**
 * Get a list of the logged in users tokens
 */
const get = () => {
	return api.request({
		url: path(""),
		method: "GET",
	});
};

/**
 * Revoke a user token / log out
 */
const revoke = async () => {
	const res = await api.request({ url: path("") });
	const revokeCtl =
		res.data.tokens[0]["@controls"][masonCtlKey.tokens.revoke];
	await api.request({
		url: revokeCtl.href,
		method: revokeCtl.method,
	});
};

/**
 * Check if the user has a valid session / is logged in. Returns
 * true if the user is logged in.
 */
const validate = async () => {
	const tokens = await get();

	if (tokens.data.tokens && tokens.data.tokens.length > 0) return true;

	return false;
};

export default {
	create,
	get,
	validate,
	revoke,
};
